export const formatPay = (type, amt) => {
  // Handle null, undefined, or non-numeric values
  if (amt === null || amt === undefined || isNaN(parseFloat(amt))) {
    return '—';
  }
  
  // Convert to number if it's a string
  const amount = typeof amt === 'string' ? parseFloat(amt) : amt;
  
  // Format based on type
  if ((type || '').toLowerCase().includes('hour')) {
    return `$${amount}/hr`;
  } else {
    return `$${Math.round(amount / 1000)}K/yr`;
  }
};

export const computeAvailability = (dateStr) => {
  // Handle null, undefined, or invalid date strings
  if (!dateStr) return 'Available Immediately';
  
  try {
    const today = new Date();
    const d = new Date(dateStr);
    
    // Check if date is valid
    if (isNaN(d.getTime())) {
      return 'Available Immediately';
    }
    
    const diffDays = Math.floor((d - today) / (1000 * 60 * 60 * 24));
    
    if (diffDays <= 14) {
      return 'Available Immediately';
    }
    
    return d.toLocaleDateString('en-US', {
      month: 'short', day: 'numeric', year: 'numeric'
    });
  } catch (error) {
    console.error('Error computing availability date:', error);
    return 'Available Immediately';
  }
};
